import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'shared-search-bar',
  standalone: false,
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss',
})
export class SearchBarComponent {
  @Input() placeholderText: string = 'Search...';
  @Output() searchTextChange = new EventEmitter<string>();
  @Output() filterReset = new EventEmitter<void>();
  searchField: string = '';

  onSearch() {
    this.searchTextChange.emit(this.searchField);
  }

  onResetFilters() {
    this.searchField = '';
    this.filterReset.emit();
  }
}
